import "whatwg-fetch";
import React from "react";
import { render } from "react-dom";
import PropTypes from "prop-types";
import createClass from "create-react-class";

// compatibility fix for old packages
React.PropTypes = PropTypes;
React.createClass = createClass;

require("babel-polyfill");
require("./polyfills");

const rootEl = window.document.querySelector("#root");

try {
  const Root = require("./components/Root").default;

  render(<Root />, rootEl);
} catch (e) {
  console.error(e);
}

if (module.hot) {
  module.hot.accept("./components/Root", () => {
    const NextRoot = require("./components/Root").default;
    render(<NextRoot />, rootEl);
  });
}
